import { format } from "date-fns";
import { ru } from "date-fns/locale";

export const formatDate = (isoDate: string): string => {
  return format(new Date(isoDate), "d MMMM yyyy 'г.'", { locale: ru });
};
